<template>
  <div
    class="md:w-[728px] mx-auto flex p-8 bg-gray-100 border border-gray-200 flex-col rounded-sm mt-20"
  >
    <h1
      class="font-sans text-xl font-semibold text-center md:text-center md:font-bold md:text-3xl"
    >
      Subscribe to our mailing list
    </h1>

    <p
      v-show="showMessage"
      :class="['text-sm', 'font-semibold', 'text-center', messageClass]"
    >
      {{ message }}
    </p>

    <div class="flex flex-row items-center justify-center mt-8 space-x-3">
      <input
        type="text"
        class="md:w-4/6 h-[48px] px-4 py-2 border border-[#ccc] rounded focus:outline outline-primary outline-1"
        v-model="email"
        placeholder="Enter your Email"
      />
      <button
        @click="JoinNewsletter"
        :disabled="loading"
        class="flex items-center justify-center w-12 h-[48px] px-2 py-1 text-white bg-primary rounded hover:bg-[#910811]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4 transition-transform stroke-2 transform-gpu hover:translate-x-2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
          />
        </svg>
      </button>
    </div>
    <p v-if="loading" class="mt-5 text-xs text-center text-primary">
      Subscribing...
    </p>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "NewsLetter",
  data() {
    return {
      email: null,
      base_url: this.$store.state.baseUrl,
      message: null,
      showMessage: false,
      loading: false,
      isError: false,
    };
  },
  computed: {
    messageClass() {
      return this.isError ? "text-red-500" : "text-teal-600";
    },
  },
  methods: {
    JoinNewsletter() {
      this.loading = true;

      axios
        .post(`${this.base_url}newsletter`, {
          email: this.email,
        })
        .then((response) => {
          this.message = response.data.message;
          this.showMessage = true;
          this.isError = false;
          this.email = null;

          setTimeout(() => {
            this.message = null;
            this.showMessage = false;
          }, 1000);
        })
        .catch((error) => {
          this.message = error.response.data.message;
          this.email = null;
          this.showMessage = true;
          this.isError = true;
          setTimeout(() => {
            this.message = null;
            this.showMessage = false;
          }, 2000);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
